import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
  Radio,
  Divider,
  Button,
  Modal,
  List,
  DatePicker,
  Switch,
  InputNumber,
  TimePicker,
} from "antd";
import { PlusOutlined, DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import CustomButton from "../../../components/custom/CustomButton";
import { apiConfig, labelConfig, staticConfig } from "../security.config";
import timezones from "../../../config/data/timezones.json";
import { template } from "@antv/g2plot/lib/utils";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import dayjs from "dayjs";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const EditUser = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const accessDays = Form.useWatch("accessDays", useForm);
  const accessTime = Form.useWatch("accessTime", useForm);
  const isTemporary = Form.useWatch("isTemporary", useForm);
  const [userDetail, setUserDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rolesList, setRolesList] = useState([]);
  const [officeData, setOfficeData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [timezonesData, setTimezonesData] = useState([]);
  const [selectStaffState, setSelectStaffState] = useState(true);
  const [rolesData, setRolesData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initialStaffData, setInitialStaffData] = useState();

  useEffect(() => {
    getDetailById(state);
    getTemplate();
  }, []);
  useEffect(() => {
    useForm.setFieldValue("passwordNeverExpires", false);
  }, []);

  const getDetailById = (userParams) => {
    setIsLoading(true);

    const url = `${apiConfig.Users}/${userParams.key}`;

    const params = {
      template: true,
    };
    let body = {
      session,
      params,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setUserDetail(objDetail);
        let tempOffice = [];
        let tempRoles = [];
        let tempTimezones = [];

        useForm.setFieldsValue({
          firstname: objDetail?.firstname,
          lastname: objDetail?.lastname,
          username: objDetail?.username,
          email: objDetail?.email,
          id: objDetail?.id,
          officeName: objDetail?.officeName,
          selectedRoles: objDetail?.selectedRoles,
          officeId: objDetail?.officeId,
          staffId: objDetail?.staff?.id,
          passwordNeverExpires: objDetail?.passwordNeverExpires,
          loginTimezone: objDetail?.timezone || null,
          loginTimeFrom: objDetail?.loginTimeFrom
            ? BOM.FormatArrayTime(objDetail?.loginTimeFrom)
            : null,
          loginTimeTo: objDetail?.loginTimeTo ? BOM.FormatArrayTime(objDetail?.loginTimeTo) : null,
          isTemporary: objDetail?.isTemporary ?? false,
          startDate: objDetail?.startDate ? dayjs(BOM.FormatArrayDate(objDetail?.startDate)) : null,
          expiryDate: objDetail?.expiryDate
            ? dayjs(BOM.FormatArrayDate(objDetail?.expiryDate))
            : null,
        });

        objDetail?.allowedOffices?.forEach((element) => {
          tempOffice.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.availableRoles
          ?.filter((role) => role.disabled === false) // ✅ only include non-disabled roles
          ?.forEach((element) => {
            tempRoles.push({
              value: element.id.toString(),
              label: element.name,
              description: element.description,
              disabled: element.disabled,
            });
          });

        tempTimezones = timezones.map((tz) => ({
          label: tz.timezonename,
          value: tz.timezonename,
        }));

        setOfficeData(tempOffice);
        setRolesData(tempRoles);
        setOfficeData(tempOffice);
        setRolesList(objDetail?.selectedRoles);
        setTimezonesData(tempTimezones);
        getStaff(objDetail?.officeId);
        setIsLoading(false);
      }
    });
  };

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.ManageUsersTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempOffice = [];
        let tempAccountData = [];
        let tempRoles = [];

        objList?.allowedOffices?.forEach((element) => {
          tempOffice.push({
            value: element.id,
            label: element.name,
          });
        });

        tempRoles =
          objList?.availableRoles
            ?.filter((role) => role.disabled === false)
            ?.map((role) => ({
              value: role.id.toString(),
              label: role.name,
              description: role.description,
              disabled: role.disabled,
            })) || [];

        setOfficeData(tempOffice);
        setRolesData(tempRoles);
      }
    });
  }

  function getStaff(value) {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, BOM.baseUrl("staff?officeId=" + value + "&status=all"), (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempStaff = [];

        objList?.forEach((element) => {
          tempStaff.push({
            value: element.id,
            label: element.displayName,
          });
        });

        setStaffData(tempStaff);

        setSelectStaffState(false);
      }
    });
  }

  function onCancel() {
    navigate("/sms0100", { replace: true });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Users}/${state.key}`;
    formValues.roles = rolesList.map((role) => `${role.id}`);
    formValues.startDate = formValues.startDate
      ? BOM.DateTime(formValues.startDate, "only-date")
      : formValues.startDate;
    formValues.expiryDate = formValues.expiryDate
      ? BOM.DateTime(formValues.expiryDate, "only-date")
      : formValues.expiryDate;
    formValues.loginTimeFrom = formValues.loginTimeFrom
      ? formValues.loginTimeFrom.format("HH:mm")
      : null;
    formValues.loginTimeTo = formValues.loginTimeTo ? formValues.loginTimeTo.format("HH:mm") : null;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.EditManageUsersMsg);
          navigate("/sms0100");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/sms0100");
          setIsLoading(false);
        },
      }
    );
  };

  const handleRoleDelete = (key) => {
    let action = "Delete  ";
    let label = key.name;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = rolesList.filter((item) => item.id !== key.id);
        setRolesList(newData);
      },

      function () {
        // No button
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.editUser}
        pageItems={staticConfig.editUsersBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}
        <Form
          form={useForm}
          layout="vertical"
          style={{ paddingTop: 20, marginBottom: 50 }}
          onFinish={onSubmit}
        >
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="username"
                    label={<Text strong>{labelConfig.userName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Input className="of-bold-disable-input" />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="firstname"
                    label={<Text strong>{labelConfig.firstName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Input className="of-bold-disable-input" />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="lastname"
                    label={<Text strong>{labelConfig.lastName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Input className="of-bold-disable-input" />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="email"
                    label={<Text strong>{labelConfig.email}</Text>}
                    rules={BOM.fieldRules("email", true)}
                  >
                    <Input className="of-bold-disable-input" />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="passwordNeverExpires"
                    label={<Text strong>{labelConfig.manageUsersOverridePassword}</Text>}
                  >
                    <Select
                      disabled
                      placeholder="Please select an option"
                      showSearch
                      options={staticConfig.yesOrNoData}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="officeId"
                    label={<Text strong>{labelConfig.branch}</Text>}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Please select an Office"
                      showSearch
                      options={officeData}
                      onSelect={(value) => getStaff(value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="staffId"
                    label={<Text strong>{labelConfig.manageUsersStaff}</Text>}
                  >
                    <Select
                      placeholder="Select a Staff"
                      showSearch
                      options={staffData}
                      onSelect={(value) => getStaff(value)}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <div
                  style={{
                    width: "100%",
                    padding: "16px",
                  }}
                >
                  <Spin spinning={isLoading} tip="Loading..." size="large">
                    <Divider orientation="left" orientationMargin="0">
                      <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                        {"Manage Roles"}
                      </Title>
                    </Divider>

                    <RolesModal
                      isModalOpen={isModalOpen}
                      setIsModalOpen={setIsModalOpen}
                      setRolesList={setRolesList}
                      rolesList={rolesList}
                      rolesData={rolesData}
                    />
                    {rolesList?.length > 0 && (
                      <List
                        itemLayout="horizontal"
                        dataSource={rolesList}
                        renderItem={(item, index) => (
                          <Card style={{ width: "100%", marginBottom: 20 }}>
                            <List.Item
                              actions={[
                                <Button
                                  type="primary"
                                  danger
                                  shape="round"
                                  size="small"
                                  onClick={() => handleRoleDelete(item)}
                                  icon={<DeleteOutlined />}
                                  style={{
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    marginLeft: "auto",
                                  }}
                                >
                                  Remove
                                </Button>,
                              ]}
                            >
                              <List.Item.Meta
                                title={item.name}
                                // description={item.description}
                              />
                            </List.Item>
                          </Card>
                        )}
                      />
                    )}
                  </Spin>
                </div>
              </Row>{" "}
              <Row>
                <div
                  style={{
                    width: "100%",
                    padding: "16px",
                  }}
                >
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                      {"User Access Control"}
                    </Title>
                  </Divider>

                  {/* <Row>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="accessDays"
                        label={
                          <Text strong>
                            {labelConfig.manageUsersAccessDays}
                          </Text>
                        }
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "Required Field",
                        //   },
                        // ]}
                      >
                        <Select
                          disabled
                          placeholder="Please select an option"
                          options={[
                            "Default workdays",
                            "Everyday (Sun - Sat)",
                            "Custom days",
                          ].map((opt) => ({
                            label: opt,
                            value: opt,
                          }))}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="accessTime"
                        label={
                          <Text strong>
                            {labelConfig.manageUsersAccessTime}
                          </Text>
                        }
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "Required Field",
                        //   },
                        // ]}
                      >
                        <Select
                          disabled
                          placeholder="Please select an option"
                          options={[
                            "Default work hours",
                            "24 hours access",
                            "Custom time",
                          ].map((opt) => ({
                            label: opt,
                            value: opt,
                          }))}
                        />
                      </Form.Item>
                    </Col>

                    {accessDays === "Custom days" && (
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          name="allowAccess"
                          label={
                            <Text strong>
                              {labelConfig.manageUsersAllowAccess}
                            </Text>
                          }
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Required Field",
                          //   },
                          // ]}
                        >
                          <Select
                            mode="multiple"
                            showSearch
                            placeholder="Select Options"
                            options={[
                              "Monday",
                              "Tuesday",
                              "Wednesday",
                              "Thursday",
                              "Friday",
                              "Saturday",
                              "Sunday",
                            ].map((day) => ({
                              label: day,
                              value: day,
                            }))}
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </Row> */}

                  <Row>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="loginTimeFrom"
                        label={<Text strong>{labelConfig.manageUsersStartTime}</Text>}
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <TimePicker
                          style={{ width: "100%" }}
                          format="HH:mm"
                          showSecond={false}
                          defaultOpenValue={dayjs("00:00", "HH:mm")}
                          popupClassName="custom-timepicker-dropdown"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="loginTimeTo"
                        label={<Text strong>{labelConfig.manageUsersEndTime}</Text>}
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <TimePicker
                          style={{ width: "100%" }}
                          format="HH:mm"
                          showSecond={false}
                          defaultOpenValue={dayjs("00:00", "HH:mm")}
                          popupClassName="custom-timepicker-dropdown"
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        name="loginTimezone"
                        label={<Text strong>{labelConfig.manageUsersTimezone}</Text>}
                        rules={[
                          {
                            required: true,
                            message: "Required Field",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Please select an option"
                          options={timezonesData}
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      span={8}
                      style={{
                        padding: "0px 8px",
                        marginBottom: 20,
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <Form.Item
                        name="isTemporary"
                        valuePropName="checked"
                        style={{ marginBottom: 0 }}
                      >
                        <Switch
                          style={{
                            backgroundColor: isTemporary ? "#92428B" : "#F2F4F7",
                          }}
                        />
                      </Form.Item>
                      <Text style={{ marginLeft: 5, marginRight: 10 }}>
                        {labelConfig.manageUsersTemporaryUser}
                      </Text>
                    </Col>
                  </Row>

                  {isTemporary && (
                    <Row>
                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          name="startDate"
                          label={<Text strong>{labelConfig.manageUsersStartDate}</Text>}
                          rules={[
                            {
                              required: true,
                              message: "Required Field",
                            },
                          ]}
                        >
                          <DatePicker
                            disabledDate={BOM.DisableBeforeCurrentDate}
                            placeholder={BOM.handlePlaceholderMsg(
                              `${labelConfig.fromDate}`,
                              "select"
                            )}
                            style={{
                              width: "100%",
                              height: 35,
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={8} style={{ padding: "0px 8px" }}>
                        <Form.Item
                          name="expiryDate"
                          label={<Text strong>{labelConfig.manageUsersEndDate}</Text>}
                          rules={[
                            {
                              required: true,
                              message: "Required Field",
                            },
                          ]}
                        >
                          <DatePicker
                            disabledDate={BOM.DisableBeforeCurrentDate}
                            placeholder={BOM.handlePlaceholderMsg(
                              `${labelConfig.toDate}`,
                              "select"
                            )}
                            style={{
                              width: "100%",
                              height: 35,
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                </div>
              </Row>
              <Form.Item>
                <Row>
                  {BOM.HasPermission("UPDATE_USER") && (
                    <CustomButton
                      content="Submit"
                      style={{
                        width: "10%",
                        marginLeft: "auto",
                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      }}
                      htmlType="submit"
                      backgroundColor="#15CCAE"
                      colorText="black"
                      hoverBackground="#4FECA0"
                    />
                  )}
                  <CustomButton
                    content="Cancel"
                    style={{
                      width: "10%",
                      marginLeft: "1%",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                    onClick={onCancel}
                  />
                </Row>
              </Form.Item>
            </Card>
          </Card>
        </Form>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);

export const RolesModal = (props) => {
  const { isModalOpen, setIsModalOpen, setRolesList, rolesList, rolesData } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleRoleSave = (formValues) => {
    const role = rolesData.find((item) => item.value === formValues.roles);

    const newRoles = {
      id: parseInt(formValues.roles, 10),
      name: role?.label,
      description: role?.description,
    };

    if (rolesList.some((role) => role.id === newRoles?.id)) {
      useForm.resetFields();
    } else {
      setRolesList([...rolesList, newRoles]);
      useForm.resetFields();
    }
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#15CCAE",
          marginBottom: 20,
        }}
      >
        Add
      </Button>

      <Modal
        title="Add User Role(s)"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={1000}
      >
        <Form form={useForm} layout="vertical" onFinish={handleRoleSave} name="roles">
          <Divider />

          <Row>
            <div
              style={{
                width: 800,
                padding: "16px",
              }}
            >
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={"Available Roles"}
                  name={"roles"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld("Role"),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg("Role", "select")}
                    options={rolesData}
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>
            </div>
          </Row>

          <Row>
            <Divider />
            <CustomButton
              content="Save"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              htmlType="submit"
              backgroundColor="#15CCAE"
              colorText="black"
              hoverBackground="#4FECA0"
            />

            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </Row>
  );
};
